import React, { createContext, useContext, useState } from 'react';
import analyticsService, { ANALYTICS_SOURCES } from '../services/analytics';

interface LoginDialogContextType {
  isOpen: boolean;
  openLoginDialog: (source?: string) => void;
  closeLoginDialog: () => void;
}

const LoginDialogContext = createContext<LoginDialogContextType | undefined>(undefined);

export const LoginDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openSource, setOpenSource] = useState<string>('');

  const openLoginDialog = (source: string = ANALYTICS_SOURCES.DIRECT_URL) => {
    setIsOpen(true);
    setOpenSource(source);
    analyticsService.trackLoginDialog('open', source);
  };
  
  const closeLoginDialog = () => {
    setIsOpen(false);
    analyticsService.trackLoginDialog('close', openSource);
  };

  return (
    <LoginDialogContext.Provider value={{ isOpen, openLoginDialog, closeLoginDialog }}>
      {children}
    </LoginDialogContext.Provider>
  );
};

/** The sign-in dialog where there is one, else undefined — for public surfaces
 *  that render with or without the provider (the newsletter box). */
export const useOptionalLoginDialog = () => useContext(LoginDialogContext);

export const useLoginDialog = () => {
  const context = useContext(LoginDialogContext);
  if (context === undefined) {
    throw new Error('useLoginDialog must be used within a LoginDialogProvider');
  }
  return context;
};